import React, { useEffect } from 'react';

import { handleOAuthCallback } from "@cj-platform/authentication-browser";

export const OauthCallback = () => {
    useEffect(() => {
        doOauthCallback()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const doOauthCallback = async () => {
        handleOAuthCallback()
    }

    return <div/>;
};